export default class DocumentsListController {
    constructor(Documents, $state) {
        this.store = Documents.reset({
            listview: 'DocumentsListView',
            persist: true
        });
        this.angularState = $state;

        this._initStore();
    }

    _initStore() {
        this.store.commit('setVm', this);
    }

    goToDetails({action, row}, store) {
        this.angularState.go('app.documents.main.details', {
            id: row.id
        });
    }
}

DocumentsListController.$inject = [
    'Documents',
    '$state'
];



// WEBPACK FOOTER //
// ./src/app/modules/documents/controllers/main/list-controller.js